export class NewsEntryTag {
  id: number;
  name: string;
  roles: string[];
  visible: boolean;
}
